<div class="validation-project-resume-container">
  @if (model) {
    <ng-validation-project-resume-table
      [model$]="validationProjectResume.asObservable()"
      [loading$]="loading$"></ng-validation-project-resume-table>
  }
</div>
